import { memo, useCallback } from 'react';
import type { GridRowIdGetter } from '@mui/x-data-grid';
import { TableGridMode } from 'consts/table';
import { date, FilterVariant } from 'consts/filters';
import { multi, single, text } from 'consts/transactions';
import { useTypedSelector } from 'hooks';
import { selectTransactionCurrencies } from 'features/general/selectors';
import {
    selectIsTransactionsLoading,
    selectIsTransactionsUninitialized,
    selectTransactionSlice
} from 'features/transactions/selectors';
import useActions from 'features/transactions/useActions';
import type { Transaction } from 'features/transactions/types';
import Table from "ui/widgets/Table";
import * as components from './components';
import {
    useRequestQueryOverrideDecorator,
    useFilterPropsOverride,
    useFiltersVisibilityRules as useVisibilityRules
} from './hooks';
import TransactionDetails from '../TransactionDetails';

const TransactionTable = () => {
    const Currencies = useTypedSelector(selectTransactionCurrencies);
    const {
        getTransactions,
        downloadCsv,
    } = useActions();

    const getRowId: GridRowIdGetter<Transaction> = useCallback(({ transactionId }: Transaction) =>
        transactionId, []);

    // const getSummableColumns = useCallback(() => allSummableColumnsAlias, []);

    return (
        <Table
            mode={TableGridMode.Transaction}
            selectIsTableUninitialized={selectIsTransactionsUninitialized}
            selectIsTableLoading={selectIsTransactionsLoading}
            selectTableDataSlice={selectTransactionSlice}
            fetchTableData={getTransactions}
            downloadCsv={downloadCsv}
            filterTypes={new Map<FilterVariant, string[]>([
                [FilterVariant.Text, text],
                [FilterVariant.DateRange, date],
                [FilterVariant.MultiOption, multi],
                [FilterVariant.SingleOption, single]
            ])}
            components={components}
            DetailPanelContent={TransactionDetails}
            getRowId={getRowId}
            requestQueryOverrideDecorator={useRequestQueryOverrideDecorator}
            LayoutProps={{
                sx: {
                    m: '24px 0px'
                }
            }}
            FiltersProps={{
                sx: {
                    m: 0
                },
                useVisibilityRules,
                useFilterPropsOverride,
                filtersModelOverrides: {
                    Currencies
                }
            }}
            // getSummableColumns={getSummableColumns}
        />
    );
};

export default memo(TransactionTable);
